import { BackendColumns, SESSION_METRICS_COLUMNS, PROSPECT_INFO_COLUMNS, CallMetricColumns, CustomMetricColumns } from "../../interfaces/table"
import { FilterOperator } from "../../interfaces/sessions"
import { CustomMetricValueType } from "../../interfaces/db"

export enum FilterColumnTypes {
    NUMERICAL = 'numerical',
    CATEGORICAL = 'categorical',
    BOOLEAN = 'boolean',
    BOOLEAN_NUMERICAL = 'boolean_numerical',
    DATE = 'date',
    DURATION = 'duration',
    PERCENTAGE = 'percentage'
}

export function getDefaultOperator(columnType: FilterColumnTypes): FilterOperator {
    switch (columnType) {
        case FilterColumnTypes.NUMERICAL: return FilterOperator.GE
        case FilterColumnTypes.CATEGORICAL: return FilterOperator.IN
        case FilterColumnTypes.BOOLEAN: return FilterOperator.EQ
        case FilterColumnTypes.BOOLEAN_NUMERICAL: return FilterOperator.EQ
        case FilterColumnTypes.DATE: return FilterOperator.GE
        case FilterColumnTypes.DURATION: return FilterOperator.GE
        case FilterColumnTypes.PERCENTAGE: return FilterOperator.GE
        default: return FilterOperator.EQ
    }
}

export function getSessionMetricsColumnType(column: SESSION_METRICS_COLUMNS): FilterColumnTypes {
    switch (column) {
        case SESSION_METRICS_COLUMNS.SCHEDULED_START: return FilterColumnTypes.DATE
        case SESSION_METRICS_COLUMNS.CREATED_AT: return FilterColumnTypes.DATE
        case SESSION_METRICS_COLUMNS.USER_ID: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.TEAM_ID: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.EXTERNAL_ACCOUNT_ID: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.ACCOUNT_ID: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.USER_NAME: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.REP_PHONE_VALUE: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.REP_PHONE_IS_LOCAL: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.AUDIO_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.PROSPECT_TRANSCRIPT_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.USER_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.CALL_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.INITIAL_RINGING_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.NUM_WORDS_PROSPECT: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.NUM_WORDS_REP: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.LANGUAGE: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.IS_USER_HANGUP: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.IS_AUTODIALER_CREATED: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.IS_AUTODIALER_HANGUP: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.IS_CONNECTED: return FilterColumnTypes.BOOLEAN 
        case SESSION_METRICS_COLUMNS.CAN_IMPROVE_EARLY_HANGUP: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.CAN_IMPROVE_NAVIGATE_MENU: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.CONNECT_TIME: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.CONNECT_IS_LIVE: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.CONNECT_IS_RECORDING: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.IS_ANSWERED: return FilterColumnTypes.BOOLEAN  
        case SESSION_METRICS_COLUMNS.ANSWERED_TIME: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.TARGET_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.GATEKEEPER_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.VOICEMAIL_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.TARGET_SPEECH: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.LIVE_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.GATEKEEPER_SPEECH: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.REP_SPEECH_WITH_GATEKEEPER: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.REP_SPEECH_WITH_TARGET: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.REP_SPEECH_DURING_VOICEMAIL_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.LONGEST_MONOLOGUE_REP_TARGET: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.NUMBER_WORDS_REP_ALL_ELIGIBLE: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.DURATION_REP_ALL_ELIGIBLE_SPEECH: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.WORDS_PER_SECOND_REP_ALL_ELIGIBLE: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.NUMBER_WORDS_TARGET_ELIGIBLE: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.DURATION_TARGET_ELIGIBLE_SPEECH: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.WORDS_PER_SECOND_TARGET_ELIGIBLE: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.NUMBER_WORDS_REP_TARGET_ELIGIBLE: return FilterColumnTypes.NUMERICAL   
        case SESSION_METRICS_COLUMNS.R_DENY_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_NAME_DENY_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_TITLE_DENY_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_TRANSFER_DENY_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_RESP_NOT_DECISION_MAKER_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_RESP_NOT_RELEVANT_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_CALL_DENY_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_EMAIL_DENY_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_DELAYED_DENY_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_MEETING_DENY_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.C_ASKS_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.C_REFERRAL_ASK_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.C_BUSINESS_ASK_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.C_RESP_CHECK_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.C_MEETING_OFFER_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.C_CALL_OFFER_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.C_EMAIL_OFFER_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_MEETING_CONFIRM: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_CALL_APPROVE: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_EMAIL_APPROVE_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_EMAIL_APPROVE: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_REFERRAL_PROVIDE: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.R_PRODUCT_INTERESTED_COUNT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.GEN_SUMMARY_TEXT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.GEN_EMAIL_TEXT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.GEN_COACHING_TEXT: return FilterColumnTypes.BOOLEAN_NUMERICAL
        case SESSION_METRICS_COLUMNS.STAGE: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.STAGE_DISPOSITION: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.TRELLUS_DISPOSITION: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.CUSTOM_DISPOSITION: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.USER_DISPOSITION: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.USER_SENTIMENT: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.USER_PURPOSE: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.PROSPECT_NAME: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.PROSPECT_PHONE_VALUE: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.PROSPECT_TRANSCRIBED: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.PROSPECT_RECORDED: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.PROSPECT_TRANSCRIPT_PERSISTED: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.PLATFORM: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.BEST_COUNTERPART: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.PRIOR_PHONE_USER_NUM_CALLS: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.PRIOR_PHONE_USER_MAX_ANSWERED_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.PRIOR_PHONE_USER_ELAPSED_SINCE_FIRST: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.PRIOR_PHONE_USER_ELAPSED_SINCE_LAST: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.PRIOR_PHONE_USER_IS_TEAM_FIRST: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.PRIOR_PHONE_TEAM_NOT_USER_NUM_CALLS: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.LANGUAGE: return FilterColumnTypes.CATEGORICAL
        case SESSION_METRICS_COLUMNS.IS_USER_HANGUP: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.IS_AUTODIALER_CREATED: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.IS_AUTODIALER_HANGUP: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.IS_CONNECTED: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.CAN_IMPROVE_EARLY_HANGUP: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.CAN_IMPROVE_NAVIGATE_MENU: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.CONNECT_TIME: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.CONNECT_IS_LIVE: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.CONNECT_IS_RECORDING: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.IS_ANSWERED: return FilterColumnTypes.BOOLEAN
        case SESSION_METRICS_COLUMNS.ANSWERED_TIME: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.TARGET_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.GATEKEEPER_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.VOICEMAIL_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.TARGET_SPEECH: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.LIVE_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.GATEKEEPER_SPEECH: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.REP_SPEECH_WITH_GATEKEEPER: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.REP_SPEECH_WITH_TARGET: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.REP_SPEECH_DURING_VOICEMAIL_DURATION: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.LONGEST_MONOLOGUE_REP_TARGET: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.NUMBER_WORDS_REP_ALL_ELIGIBLE: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.DURATION_REP_ALL_ELIGIBLE_SPEECH: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.WORDS_PER_SECOND_REP_ALL_ELIGIBLE: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.NUMBER_WORDS_REP_TARGET_ELIGIBLE: return FilterColumnTypes.NUMERICAL
        case SESSION_METRICS_COLUMNS.DURATION_REP_TARGET_ELIGIBLE_SPEECH: return FilterColumnTypes.DURATION
        case SESSION_METRICS_COLUMNS.WORDS_PER_SECOND_REP_TARGET_ELIGIBLE: return FilterColumnTypes.NUMERICAL
        default: return FilterColumnTypes.BOOLEAN
    }
}

export function getProspectInfoColumnType(column: PROSPECT_INFO_COLUMNS): FilterColumnTypes {
    switch (column) {
        case PROSPECT_INFO_COLUMNS.SCHEDULED_START: return FilterColumnTypes.DATE
        case PROSPECT_INFO_COLUMNS.PROSPECT_PHONE_VALUE: return FilterColumnTypes.NUMERICAL
        case PROSPECT_INFO_COLUMNS.COMPANY_SIZE_MIN: return FilterColumnTypes.NUMERICAL
        case PROSPECT_INFO_COLUMNS.COMPANY_SIZE_MAX: return FilterColumnTypes.NUMERICAL
        case PROSPECT_INFO_COLUMNS.SESSION_ID: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.USER_ID: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PLATFORM: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PLATFORM_TENANT_ID: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PLATFORM_PERSON_ID: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PLATFORM_COMPANY_ID: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PLATFORM_PERSON_URL: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PROSPECT_PHONE_TYPE: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.XREF_PLATFORM: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.XREF_PERSON_ID: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.XREF_COMPANY_ID: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.XREF_PERSON_URL: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.CADENCE: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.CADENCE_2: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.CADENCE_3: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.CADENCE_STEP: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.CADENCE_STEP_2: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.CADENCE_STEP_3: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PROSPECT_NAME: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PROSPECT_TITLE: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PROSPECT_OCCUPATION: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PROSPECT_SENIORITY: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PROSPECT_LOCATION: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PROSPECT_LINKEDIN: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PROSPECT_EMAIL: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PROSPECT_PHONE_OTHER_1: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PROSPECT_PHONE_OTHER_2: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.COMPANY_NAME: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.COMPANY_LINKEDIN: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.COMPANY_URL: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.COMPANY_INDUSTRY: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.COMPANY_INDUSTRY_2: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.COMPANY_INDUSTRY_3: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.COMPANY_PERSONA: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PROSPECT_LIST: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PROSPECT_LIST_2: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.PROSPECT_LIST_3: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.MARKET: return FilterColumnTypes.CATEGORICAL
        case PROSPECT_INFO_COLUMNS.LEAD_TYPE: return FilterColumnTypes.CATEGORICAL
        default: return FilterColumnTypes.CATEGORICAL
    }
}

export function getCallMetricColumnType(column: CallMetricColumns): FilterColumnTypes {
    switch (column) {
        case CallMetricColumns.IS_INBOUND: return FilterColumnTypes.BOOLEAN
        case CallMetricColumns.IS_TRELLUS_TELEPHONY: return FilterColumnTypes.BOOLEAN
        case CallMetricColumns.IS_AUTODIAL: return FilterColumnTypes.BOOLEAN
        case CallMetricColumns.HAS_CUSTOMER_VOICEMAIL: return FilterColumnTypes.BOOLEAN
        case CallMetricColumns.HAS_AGENT_VOICEMAIL: return FilterColumnTypes.BOOLEAN
        case CallMetricColumns.HAS_PRERECORDED_VOICEMAIL: return FilterColumnTypes.BOOLEAN
        case CallMetricColumns.CUSTOMER_ENDED: return FilterColumnTypes.BOOLEAN
        case CallMetricColumns.CUSTOMER_AUDIO_UPLOADED: return FilterColumnTypes.BOOLEAN
        case CallMetricColumns.CUSTOMER_TRANSCRIPT_UPLOADED: return FilterColumnTypes.BOOLEAN
        case CallMetricColumns.STARTED_AT: return FilterColumnTypes.DATE
        case CallMetricColumns.CUSTOMER_JOINED_AT: return FilterColumnTypes.DATE
        case CallMetricColumns.CUSTOMER_LIVE_AT: return FilterColumnTypes.DATE
        case CallMetricColumns.CUSTOMER_LIVE_KNOWN_AT: return FilterColumnTypes.DATE
        case CallMetricColumns.FIRST_USER_JOINED_AT: return FilterColumnTypes.DATE
        case CallMetricColumns.CALL_DURATION: return FilterColumnTypes.DURATION
        case CallMetricColumns.CUSTOMER_DURATION: return FilterColumnTypes.DURATION
        case CallMetricColumns.LIVE_DURATION: return FilterColumnTypes.DURATION
        case CallMetricColumns.CUSTOMER_DROPPED_DURATION: return FilterColumnTypes.DURATION
        case CallMetricColumns.AGENT_DROPPED_DURATION: return FilterColumnTypes.DURATION
        case CallMetricColumns.PARALLEL_LINES: return FilterColumnTypes.NUMERICAL
        case CallMetricColumns.SESSION_ID: return FilterColumnTypes.CATEGORICAL
        case CallMetricColumns.TEAM_ID: return FilterColumnTypes.CATEGORICAL
        case CallMetricColumns.CALL_TYPE: return FilterColumnTypes.CATEGORICAL
        default: return FilterColumnTypes.BOOLEAN
    }
}

export function getColumnType(column: BackendColumns): FilterColumnTypes {
    if (Object.values(SESSION_METRICS_COLUMNS).map((v) => v.toString()).includes(column.toString())) return getSessionMetricsColumnType(column as SESSION_METRICS_COLUMNS)
    if (Object.values(PROSPECT_INFO_COLUMNS).map((v) => v.toString()).includes(column.toString())) return getProspectInfoColumnType(column as PROSPECT_INFO_COLUMNS)
    if (Object.values(CallMetricColumns).map((v) => v.toString()).includes(column.toString())) return getCallMetricColumnType(column as CallMetricColumns)
    
    // Check if this is a custom metric column
    if (Object.values(CustomMetricColumns).includes(column as CustomMetricColumns) && 
        column !== CustomMetricColumns.SESSION_ID && 
        !column.startsWith('text_')) {
        return getCustomMetricColumnType(column)
    }
    
    return FilterColumnTypes.BOOLEAN
}

export function getCustomMetricColumnType(column: string): FilterColumnTypes {
    // This function will be called from the component level where we have access to custom definitions
    // For now, default to numerical since most custom metrics are numerical
    // The actual type determination will happen in the StaticFilter component
    return FilterColumnTypes.NUMERICAL
}